import React, { useState, useEffect } from 'react';
import { RecoilRoot } from 'recoil';
import { useTranslation } from 'react-i18next';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import parse from 'html-react-parser';
import LandingPage from '../lading-page';
import Header from '../../components/header';
import Footer from '../../components/footer';
import { ContentSpinner } from '../../components/spinner';
import { ISiteWrapper } from '../../models/SiteWrapper';
import { TabContextProvider } from '../../context/tabContext';
import {
  getLangSite,
  loadSearchBarAndDropDownMenu,
  validateForChineseLanguage,
  wrapDataReturnDataForUnitTest
} from '../../ultils';

interface IMainProps {
  analytics: any[];
}

const MainLayout: React.FC<IMainProps> = ({ analytics }) => {
  const [countRenderSearchBar, setCountRenderSearchBar] = useState(0);
  const [renderStatus, setRenderStatus] = useState(false);
  const [siteWrapper, setSiteWrapper] = useState<ISiteWrapper>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { t } = useTranslation();

  useEffect(() => {
    const [siteWrapper] = analytics;
    setSiteWrapper(siteWrapper);
  }, []);

  let helmetContent;
  if (siteWrapper && renderStatus) {
    const fullScript =
      siteWrapper?.scripts + siteWrapper?.head + siteWrapper?.header;

    const scriptsHasStringElement: JSX.Element[] | undefined = parse(
      fullScript || ''
    ) as JSX.Element[];

    const scripts = scriptsHasStringElement.filter(
      (script: JSX.Element) => typeof script !== 'string'
    );

    const styles: string = siteWrapper ? siteWrapper.styles : '';

    const dangerouslySetScripts = scripts.filter((script: JSX.Element) => {
      return script.props.dangerouslySetInnerHTML;
    });
    const srcScripts = scripts.filter((script: JSX.Element) => {
      return script.props.src;
    });
    let countryIndex = 0;
    scripts.forEach((script, index) => {
      if (script.props.src?.includes('countryselector')) {
        countryIndex = index;
      }
      if (script.props.src) {
        srcScripts.push(script);
      }
    });
    srcScripts.splice(countryIndex, 1);
    const descScripts: JSX.Element[] = [];
    const existSrc: { [key: string]: boolean } = {};
    srcScripts.forEach((item) => {
      if (existSrc[item.props.src]) {
        return;
      }
      existSrc[item.props.src] = true;
      descScripts.push(item);
    });

    helmetContent = (
      <HelmetProvider>
        <Helmet>
          <link rel="canonical" href={window.location.href} />
          <meta name="description" content={t('xref-meta-description')} />
          <meta name="keywords" content={t('xref-meta-keywords')} />
          {parse(styles || '')}
          {(dangerouslySetScripts || []).map((script, index) => {
            return (
              <script
                type={script.props.type}
                key={index}
                async
              >{`${script.props.dangerouslySetInnerHTML.__html}`}</script>
            );
          })}
          {descScripts}
          {validateForChineseLanguage(getLangSite('en')) ? (
            <script src="//players.brightcove.net/1571595843001/41ecSd4l2x_default/index.min.js"></script>
          ) : null}
        </Helmet>
      </HelmetProvider>
    );
  }

  useEffect(() => {
    // ! It will run until searchBarModule define
    if (!wrapDataReturnDataForUnitTest((window as any).searchBarModule)) {
      setCountRenderSearchBar(countRenderSearchBar + 1);
    } else {
      loadSearchBarAndDropDownMenu();
    }
  }, [countRenderSearchBar]);

  useEffect(() => {
    if (siteWrapper && !renderStatus) {
      setRenderStatus(true);
    }

    const timmer = setTimeout(() => {
      if (renderStatus && siteWrapper) {
        setIsLoading(false);
      }
    }, 100);

    return () => clearInterval(timmer);
  }, [siteWrapper, renderStatus]);

  const title = t('xref-seo-title');

  // ! Init searchBarModule
  loadSearchBarAndDropDownMenu();

  return (
    <React.Fragment>
      {isLoading ? <ContentSpinner /> : null}
      {helmetContent}
      <Header id="primary-header" header={siteWrapper?.header} />
          <div className="layout-main">
        <div className="content-column">
          {title !== 'xref-seo-title' && (
            <RecoilRoot>
              <TabContextProvider>
                <LandingPage />
              </TabContextProvider>
            </RecoilRoot>
          )}
        </div>
      </div>
      <Footer footer={siteWrapper?.footer} />
    </React.Fragment>
  );
};

export default MainLayout;
